"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyBasket = void 0;
var react_1 = __importDefault(require("react"));
var EmptyBasket = function () {
    return (react_1.default.createElement("div", { className: "flex flex-col items-center justify-center h-full" },
        react_1.default.createElement("div", { className: "text-2xl font-bold" }, "Your basket is empty"),
        react_1.default.createElement("div", { className: "text-sm text-gray-500" }, "Add some items to your basket")));
};
exports.EmptyBasket = EmptyBasket;
